var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-doc-list-component",
      attrs: { "data-grm-comp": "ListDetail" },
    },
    [
      _c(
        "ul",
        { staticClass: "room-doc-list" },
        _vm._l(_vm.roomDocFile.pages, function (docPage, i) {
          return _c(
            "li",
            {
              key: docPage.docPageId,
              staticClass: "room-doc-item",
              class: [
                {
                  selected: docPage.docPageId === _vm.roomDocFile.currDocPageId,
                },
              ],
            },
            [
              _c("div", {
                staticClass: "room-doc-select-button",
                on: {
                  click: function ($event) {
                    return _vm.setCurrentPage(docPage.docPageId)
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "room-doc-page" },
                [
                  _c("p", { staticClass: "room-doc-page-number" }, [
                    _vm._v(_vm._s(i + 1)),
                  ]),
                  _c(
                    "lazy-component",
                    {
                      staticClass: "room-doc-thumb pre",
                      on: {
                        show: function ($event) {
                          return _vm.loadPageThumbnail(docPage, $event)
                        },
                      },
                    },
                    [_c("img")]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }